// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__LE-F9","app-icon":"styles_app-icon__YmVdT","title":"styles_title__GPC3J"};